import * as React from "react";
function SpinnerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    className: "lds-spin",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    style: {
      background: "0 0"
    },
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    transform: "scale(1.71889)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1.3333333333333333s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-1.3333333333333333s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40 -55.687 126.657)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.889,
    transform: "scale(1.83)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1.1666666666666667s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-1.1666666666666667s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80 -16.794 69.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.778,
    transform: "scale(1.94111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-1s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 -1.434 46.362)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.667,
    transform: "scale(1.05222)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.8333333333333334s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.8333333333333334s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160 8.592 31.524)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.556,
    transform: "scale(1.16333)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.6666666666666666s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.6666666666666666s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-160 17.408 18.476)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.444,
    transform: "scale(1.27445)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.5s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.5s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-120 27.434 3.638)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.333,
    transform: "scale(1.38556)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.3333333333333333s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.3333333333333333s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-80 42.794 -19.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.222,
    transform: "scale(1.49667)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.16666666666666666s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.16666666666666666s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-40 81.687 -76.657)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fillOpacity: 0.111,
    transform: "scale(1.60778)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "2 2;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1.5s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))));
}
const ForwardRef = React.forwardRef(SpinnerIcon);
export default ForwardRef;